import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.css']
})
export class CancellationPolicyComponent {

  constructor(private router: Router) { }

  // goToTermsConditions() {
  //   this.router.navigate(['/terms-conditions']);
  // }
}
